import {useEffect,useState} from 'react';
import {chicagoDate,selectCurrentFlyers,type PublicFlyer} from '../lib/flyers/publicFlyers';

export function useCurrentFlyers(zipcode?: string | null) {
  const [today,setToday]=useState('');
  const [published,setPublished]=useState<PublicFlyer[]>([]);
  useEffect(()=>{
    const tick=()=>setToday(chicagoDate());
    tick();const timer=window.setInterval(tick,60*60*1000);
    return()=>window.clearInterval(timer);
  },[]);
  useEffect(()=>{
    if (typeof fetch !== 'function') return;
    const controller=new AbortController();
    fetch('/api/partners/flyers',{signal:controller.signal})
      .then(r=>r.ok?r.json():{flyers:[]})
      .then(data=>{
        if (!controller.signal.aborted && Array.isArray(data.flyers)) setPublished(data.flyers);
      })
      .catch(()=>{if(!controller.signal.aborted)setPublished([])});
    return()=>controller.abort();
  },[]);
  return selectCurrentFlyers(published,today,zipcode);
}
